/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { DotsNavigationContent, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import Dummy from "./Dummy"
import { ModalPrimitive } from "../primitive"

/* Protopia Ecosystem component */
export interface IModalProps {
    section: ILandingSection
    data: DotsNavigationContent
}
const Modal = (props: IModalProps): JSX.Element => {
    const {data} = props
    useEffect(() => {
        addCSSClass(
            `landing-modal-${props.section.id}`,
            `.landing-modal-${props.section.id} {
                
            }
            `
        )
        
        return () => {
            removeCSSClass(`landing-modal-${props.section.id}`)
        }
    },[ ])

     return <div className={`pe-modal-container landing-content-container`} data-type={ data.type } data-content-id={ data.id }>
        {
            !!data.content
                ?
                <ModalPrimitive
                    primitive={{
                        ...(data ), 
                        section : props.section,
                    } as any }
                />
                :
                <Dummy {...{ 
                    ...{
                        data: {
                            ...data,
                            className: ` ${data.className} landing-navigation-container-${props.section.id} `
                    },
                    }, 
                    ...props 
                }} />
        }
        
    </div>
}
export default Modal